import { Directive, inject, input } from '@angular/core';
import { copyToClipboard } from '../public/util/navigator.utils';
import { NotifyService } from '../service/notify.service';

@Directive({
  selector: '[panCopyText]',
  standalone: true,
  host: {
    '(click)': 'copy()',
  },
})
export class CopyTextDirective {
  private notifyService = inject(NotifyService);

  public panCopyText = input.required<string>();

  async copy() {
    try {
      await copyToClipboard(this.panCopyText());
      this.notifyService.notify('Copied to clipboard');
    } catch {
      this.notifyService.notify('Failed to copy to clipboard, please copy manually');
    }
  }
}
